import React from 'react'
import { useTranslation } from 'react-i18next'

import {
    readCompanies,
    saveCompany,
} from '../helpers'

interface CompanyEntity {
    uid?: string
    name: string
    [key: string]: unknown
}

interface CompanyFormProps {
    editedCompany: CompanyEntity
    setEditedCompanyForm: (key: keyof CompanyEntity, value: string) => void
    successSaveFunction?: () => void
}

/**
 * Simple company create / edit form used by the super admin UI.
 */
const CompanyForm = ({
    editedCompany,
    setEditedCompanyForm,
    successSaveFunction,
}: CompanyFormProps) => {
    const { t } = useTranslation()

    const handleSave = (): void => {
        saveCompany(editedCompany)
            .then(() => {
                if (typeof successSaveFunction === 'function') {
                    successSaveFunction()
                }

                readCompanies()
            })
    }

    return (
        <div className="d-flex flex-column p-3">
            <div className="form-group">
                <label htmlFor="company-name">
                    {t('company.form.name')}
                </label>
                <input
                    type="text"
                    className="form-control"
                    id="company-name"
                    placeholder="Název společnosti"
                    value={editedCompany.name}
                    onChange={event => setEditedCompanyForm('name', event.target.value)}
                />
            </div>

            {/* @TODO - zde bude ještě nastavení práv k jednotkám */}

            <div className="form-group row">
                <div className="col-sm-10">
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleSave}
                    >
                        {t('company.form.save')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CompanyForm
